'use client';

import { useAdminRecommendations } from '@/hooks/use-admin-recommendations';

import { AiRecommendationsPanelView } from '@slims/ui/organisms';
import {
	ADMIN_CAT_LABELS,
	type AdminRec,
	type AdminRecCategory,
	fmtRecDateTime,
	type RecCtx,
} from '@/lib/admin-recs';
import { useAdminRecFeedback } from '@/hooks/use-admin-rec-feedback';

interface AiRecommendationsPanelProps {
	tenantId: string;
	ctx: RecCtx;
	/** Energia condivisa del mese (kWh) per KPI/chat contesto. */
	condivisa?: number;
	/** Azione "Spiega con AI Coach" (sidebar = chat, notifiche = naviga a MySlims). */
	onExplain?: (rec: AdminRec) => void;
	explainLabel?: string;
}

const CATEGORIES: AdminRecCategory[] = ['ottimizzazione', 'manutenzione'];

export function AiRecommendationsPanel({
	tenantId,
	onExplain,
	explainLabel,
}: AiRecommendationsPanelProps) {
	const { applied, setFeedback, clearFeedback } = useAdminRecFeedback(tenantId);
	const recs = useAdminRecommendations(tenantId);
	if (!recs.length) return null;

	return (
		<AiRecommendationsPanelView
			recs={recs}
			categories={CATEGORIES}
			categoryLabels={ADMIN_CAT_LABELS}
			applied={applied}
			formatDateTime={fmtRecDateTime}
			onFeedback={setFeedback}
			onClearFeedback={clearFeedback}
			onExplain={onExplain}
			explainLabel={explainLabel}
		/>
	);
}

export { ADMIN_RECS } from '@/lib/admin-recs';
export type { AdminRec, RecCtx } from '@/lib/admin-recs';
